import { Pipe, PipeTransform } from '@angular/core';
import { PriceComponentResponse } from '../../../core/clients/omni-core/models';

@Pipe({
  name: 'priceCurrencyUnit',
})
export class SupplierContractPriceCurrencyUnitPipe implements PipeTransform {
  transform(value: PriceComponentResponse['currencyUnit']): string {
    switch (value) {
      case 'CENTS':
        return 'cockpit.supplierContracts.units.currencyUnit.CENTS';
      case 'EURO':
        return 'cockpit.supplierContracts.units.currencyUnit.EURO';
      default:
        return value;
    }
  }
}
